import React from "react";

const Services = () => {
  const features = [
    "Specialist UK immigration & family solicitors",
    "Transparent fixed fees",
    "Approved & regulated law firm",
    "Dedicated solicitor support",
    "Expert representation",
    "Birmingham Based Law Firm",
  ];

  return (
    <section id="services" className="bg-[#F8F9FA] py-16 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Column: Image Container */}
          <div className="relative pb-6 lg:pb-0">
            <div className="relative rounded-3xl overflow-hidden shadow-lg min-h-[380px] sm:min-h-[460px] lg:min-h-[540px] h-full">
              <img
                src="/about-firm.jpg"
                alt="Blackhorse Law legal texts and robes"
                className="w-full h-full object-cover rounded-3xl"
              />
            </div>
          </div>

          {/* Right Column: Information & Feature Cards */}
          <div className="space-y-6">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[rgb(26,36,58)] leading-[1.15]">
              Committed to you.<br />
              Focused on your {" "}
              <span className="italic font-serif font-normal text-[#C9A04A]">
                future
              </span>
            </h2>

            <div className="space-y-4 text-justify text-slate-600 text-sm sm:text-base leading-relaxed">
              <p>
                At Blackhorse Law, we provide tailored advice and dedicated representation in immigration and family law. Based in Birmingham, we help individuals, families and businesses navigate complex legal matters with clarity and confidence.
              </p>
              <p>
                We take the time to understand what matters most to you. Combining legal knowledge with careful preparation and a clear strategy, we work to protect your interests and pursue the best possible outcome. At every stage, you can expect honest advice, personal attention and transparent information about costs.
              </p>
            </div>

            {/* 6 Feature badges in 2 columns */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5 pt-2">
              {features.map((feature, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-xl p-3.5 sm:p-4 border border-slate-100 shadow-sm flex items-center gap-3 transition-all duration-200 hover:shadow-md"
                >
                  <span className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-[#C9A04A] text-white flex items-center justify-center shrink-0">
                    <svg
                      className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth={2.5}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </span>
                  <span className="text-xs sm:text-sm font-semibold text-[rgb(26,36,58)]">
                    {feature}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
